import {
  type ProofPreviewModalProps as SharedProofPreviewModalProps,
  ProofPreviewModal as SharedProofPreviewModal,
} from '@diamond/shared/ui/proof-preview-modal';

export type ProofPreviewModalProps = SharedProofPreviewModalProps;
export const ProofPreviewModal = SharedProofPreviewModal;
